/**
 * lucide-react v0.0.1 - ISC
 */

import createLucideIcon from '../createLucideIcon.mjs';

const Archive = createLucideIcon("Archive", [
  [
    "rect",
    { width: "20", height: "5", x: "2", y: "4", rx: "2", key: "uhwcea" }
  ],
  ["path", { d: "M4 9v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9", key: "shkvi4" }],
  ["path", { d: "M10 13h4", key: "ytezjc" }]
]);

export { Archive as default };
//# sourceMappingURL=archive.mjs.map
